export default (state = false, action) => {
  switch (action.type) {
    case 'TOGGLE_LOADING':
      return !state;
    case 'LOGOUT':
      return false;
    default:
      return state;
  }
};
